import { Routes } from '@angular/router';
import { authGuard } from '@app/core/auth';

export const routes: Routes = [
  { path: '', redirectTo: '/sites', pathMatch: 'full' },
  {
    path: 'sites',
    loadComponent: () => import('./features/sites/pages/sites.component'),
    canActivate: [authGuard]
  },
  {
    path: 'clients-lies',
    loadComponent: () => import('./features/clients-lies/pages/clients-lies.component'),
    canActivate: [authGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./pages/unauthorized/unauthorized.component')
  },
  { path: '**', redirectTo: '/sites' }
];
